import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.project.$urlSegment._index';
import { DetailBackdropMark } from '~/ui-rocco/pages/detail-shared/DetailBackdropMark';

/**
 * The practice's name, very large and very soft, behind the band under the
 * banner.
 *
 * Black on the page's near-black ground, so it reads as a texture in the
 * surface rather than a word set on it. It was the ArchiPro "A", which said
 * whose platform this is on a page about whose building it is; the name says
 * the second.
 *
 * Behind the band's content, but not behind the page: a negative z-index would
 * drop it under `main`'s own dark background and it would never appear, so
 * the mark takes z-0, the band's content z-10, and the sections below the band
 * sit on a z-10 layer of their own.
 */
export const ProjectBackdropMark = () => {
    const { project } = useLoaderData<typeof loader>();
    return <DetailBackdropMark name={project.Professional?.Title} />;
};
